import { ORGANIZATION_STATUS, OrganizationStatusType } from '@/bundle/_Opco/types/types';
import { ORGANIZATION_USER_STATUS, OrganizationUserStatusType } from '@/const/user';

export const isInvitedOrganizationUser = (status: OrganizationUserStatusType) => {
  return status === ORGANIZATION_USER_STATUS.INVITED;
};

export const isBlockedOrganizationUser = (status: OrganizationUserStatusType) => {
  return status === ORGANIZATION_USER_STATUS.BLOCKED;
};

export const isUnconfirmedOrganizationUser = (status: OrganizationUserStatusType) => {
  return status === ORGANIZATION_USER_STATUS.UNCONFIRMED;
};

export const isActiveOrganizationUser = (status: OrganizationUserStatusType) => {
  return status === ORGANIZATION_USER_STATUS.ACTIVE;
};

export const isActiveOrganizationStatus = (status: OrganizationStatusType) => {
  return status === ORGANIZATION_STATUS.ACTIVE;
};

export const isBlockedOrganizationStatus = (status: OrganizationStatusType) => {
  return status === ORGANIZATION_STATUS.BLOCKED;
};
